import { render } from "./on_behalf_onboarding.html?vue&type=template&id=2be79a12&external"
import script from "./on_behalf_onboarding.js?vue&type=script&lang=js&external"
export * from "./on_behalf_onboarding.js?vue&type=script&lang=js&external"

import "@/assets/css/index.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__